// import components
import { Box } from '@mui/material';
import { DateNavigation } from 'components/shared';
import PlanUnitSelector from 'components/shared/PlanUnitSelector';
import SwitcherComponent from 'components/admin-portal/BaseTabsRouting/components/Headers/SwitcherComponent';
import { PlanUnitSelectorContainer, StyledHeader, Top } from './Header.styles';

// import types

import { HeaderProps } from './Header.types';
import { DateNavContainer } from 'components/logs/logs.styles';
import { useCallback } from 'react';
import { SingleOrRange } from 'components/shared/DateNavigation/DateNavigation.types';
import { StyledBoxFlexJustifyEnd } from 'components/shared/Box/Box.styles';
import MenuButton from 'components/shared/MenuButton';
import { useTranslation } from 'react-i18next';

const Header = (props: HeaderProps) => {
  const { t } = useTranslation();
  const {
    onSelectPlanUnit,
    setSelectedDateRange,
    setSelectedDate,
    selectedDateRange,
    period,
    showPlanUnitSelector,
    showSwitcherComponent = false,
    switcherComponentData,
    showCustomMenuItemLabel,
    allowDateNavigationMenuOptions = true,
    dateNavigationOptions,
    showActions,
    selection = [],
    menuOptions,
    onAction
  } = props;

  const handleSelectedDateChange = useCallback<(date: SingleOrRange) => void>(
    (date) => {
      if (period === 'custom') {
        setSelectedDateRange(Array.isArray(date) ? date : undefined);
      } else {
        setSelectedDate(date as Date | null);
      }
    },
    [period, setSelectedDate, setSelectedDateRange]
  );

  const defaultOptions = [
    {
      label: t('dayLimitViolations.payOut'),
      onClick: () => onAction?.()
    }
  ];
  return (
    <StyledHeader as="header">
      <Top>
        <Box>
          {showPlanUnitSelector && onSelectPlanUnit && (
            <PlanUnitSelectorContainer>
              <PlanUnitSelector onSelected={onSelectPlanUnit} />
            </PlanUnitSelectorContainer>
          )}

          {showSwitcherComponent && switcherComponentData && (
            <SwitcherComponent
              tabbedElement={switcherComponentData?.tabbedElement}
              tabulatedItems={switcherComponentData?.tabulatedItems}
              setTabbedElement={switcherComponentData?.setTabbedElement}
              disableRouting={switcherComponentData?.disableRouting}
              showCustomMenuItemLabel={showCustomMenuItemLabel}
            />
          )}
        </Box>
        <DateNavContainer>
          <DateNavigation
            defaultPeriod={period || 'month'}
            options={dateNavigationOptions}
            defaultDateRange={selectedDateRange}
            onDateChange={handleSelectedDateChange}
            allowMenuOptions={allowDateNavigationMenuOptions}
          />
        </DateNavContainer>
        {showActions && (
          <StyledBoxFlexJustifyEnd>
            <MenuButton
              label={t('actions')}
              disabled={selection.length === 0}
              options={menuOptions ?? defaultOptions}
            />
          </StyledBoxFlexJustifyEnd>
        )}
      </Top>
    </StyledHeader>
  );
};

export default Header;
